import { prepareWideSmallBanner } from '~/src/features/internetV2/helpers/transformer';

export const speed = [
    {
        title: <>В&nbsp;6&nbsp;раз&nbsp;быстрее</>,
        description: <>Скачается фильм в&nbsp;4к<br/>объемом 30&nbsp;Гб</>,
    },
    {
        title: <>В&nbsp;9&nbsp;раз&nbsp;быстрее</>,
        description: <>Будет скачиваться сериал<br/>объемом 60&nbsp;Гб</>,
    },
    {
        title: <>В&nbsp;8&nbsp;раз&nbsp;быстрее</>,
        description: <>Скачается игра<br/>объемом 85&nbsp;Гб</>,
    },
].map(prepareWideSmallBanner({ section: 'main', category: 'speed' }));

export const statistics = [
    {
        title: <>93% клиентов довольны&nbsp;нами</>,
        description: <>По&nbsp;нашим исследованиям</>,
    },
    {
        title: <>10&nbsp;000 +</>,
        description: 'Параметров работы сети. Отслеживаем постоянно',
    },
    {
        title: <>Каждые&nbsp;30&nbsp;сек</>,
        description: <>Проверяем скорость<br />интернета</>,
    },
].map(prepareWideSmallBanner({ section: 'main', category: 'statistics' }));
